import { USE_GPS } from "../../../config/gpsConfig.js";

// マップデータを正規化する関数
const normalizeMapJson = (mapData) => {
  if (!mapData || typeof mapData !== "object") return {};
  if (!Array.isArray(mapData.areas)) return mapData;

  const buildings = {};

  mapData.areas.forEach((area) => {
    const areaId = area?.area_id ?? null;
    const areaName = area?.area_name ?? "";
    const areaNameEn = area?.area_name_en ?? "";

    (area?.buildings ?? []).forEach((building) => {
      if (!building?.building_id) return;
      buildings[building.building_id] = {
        ...building,
        area_id: areaId,
        area_name: areaName,
        area_name_en: areaNameEn,
      };
    });
  });

  return buildings;
};

export async function loadMapData() {
  try {
    const dataJson = await import("../../../json/campus_data.json");

    const mapJson = await Promise.all(
      dataJson.default.campusList.map(async (campus) => {
        try {
          const data = await import(`../../../json/map_${campus.code}.json`);
          return normalizeMapJson(data.default);
        } catch {
          return {};
        }
      })
    );

    const mapIconJson = await Promise.all(
      dataJson.default.campusList.map(async (campus) => {
        try {
          const data = await import(
            `../../../json/map_${campus.code}_icon.json`
          );
          return data.default;
        } catch {
          return [];
        }
      })
    );

    const mapModelJson = await Promise.all(
      dataJson.default.campusList.map(async (campus) => {
        if (!USE_GPS) return null;
        try {
          const data = await import(
            `../../../json/map_${campus.code}_model.json`
          );
          return data.default || data;
        } catch {
          return null;
        }
      })
    );

    const mapSvg = dataJson.default.campusList.map((campus) => {
      return `${process.env.PUBLIC_URL}/svg/map_${campus.code}.svg`;
    });

    return { mapJson, mapIconJson, mapModelJson, mapSvg };
  } catch (error) {
    console.error("Error loading map data:", error);
    throw error;
  }
}
